import { getDefaultValue } from '@draftkings/sportsbook-common-utils';

export const addUniqueTags = (tags?: string[], newTags?: string[]): string[] => {
    return [...new Set([...getDefaultValue(tags, []), ...getDefaultValue(newTags, [])])];
};
